export default __webpack_public_path__ + "static/media/annex11.663b0cad.png";